import { ReactComponent as Flag } from "../../assets/flag/us-flag.svg";
import { ReactComponent as ESFLAG } from "../../assets/flag/es-flag.svg";

export const languageConstant = [
  { id: 0, title: "EN", flag: Flag, value: "en" },
  { id: 1, title: "ES", flag: ESFLAG, value: "es" },
];
